module.exports = __webpack_public_path__ + "static/media/seasonal_riser_grey.1549e288.svg";